import { render, staticRenderFns } from "./ModalCustomerMessageDevices.vue?vue&type=template&id=c0ceb886"
import script from "./ModalCustomerMessageDevices.vue?vue&type=script&lang=js"
export * from "./ModalCustomerMessageDevices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports